/**
 * Persists orders list UI prefs per tenant (Opções quick action).
 */
export const ORDERS_LAST_OPTIONS_ACTION_BY_TENANT_KEY =
  "adatis.orders.lastOptionsActionByTenant";

export type OrdersOptionsActionPreference = "export_csv" | "guide";

const ORDERS_OPTIONS_ACTIONS: OrdersOptionsActionPreference[] = [
  "export_csv",
  "guide",
];

type StringByTenantMap = Record<string, string>;

const readMap = (key: string): StringByTenantMap => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = localStorage.getItem(key);

    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as unknown;

    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }

    return parsed as StringByTenantMap;
  } catch {
    return {};
  }
};

const writeMap = (key: string, map: StringByTenantMap): void => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
};

export const getOrdersLastOptionsActionForTenant = (
  tenantId: number | null | undefined
): OrdersOptionsActionPreference | null => {
  if (tenantId == null || !Number.isFinite(tenantId)) {
    return null;
  }

  const value = readMap(ORDERS_LAST_OPTIONS_ACTION_BY_TENANT_KEY)[String(tenantId)];

  return ORDERS_OPTIONS_ACTIONS.includes(value as OrdersOptionsActionPreference)
    ? (value as OrdersOptionsActionPreference)
    : null;
};

export const setOrdersLastOptionsActionForTenant = (
  tenantId: number | null | undefined,
  action: OrdersOptionsActionPreference
): void => {
  if (tenantId == null || !Number.isFinite(tenantId)) {
    return;
  }

  const map = readMap(ORDERS_LAST_OPTIONS_ACTION_BY_TENANT_KEY);
  map[String(tenantId)] = action;
  writeMap(ORDERS_LAST_OPTIONS_ACTION_BY_TENANT_KEY, map);
};
